import { render, staticRenderFns } from "./TaskLogItem.vue?vue&type=template&id=980e3976&scoped=true"
import script from "./TaskLogItem.vue?vue&type=script&lang=js"
export * from "./TaskLogItem.vue?vue&type=script&lang=js"
import style0 from "./TaskLogItem.vue?vue&type=style&index=0&id=980e3976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980e3976",
  null
  
)

export default component.exports